export default __webpack_public_path__ + "static/media/cr4.a5646bd7.jpg";